export const apiConstants = {
  url: "/api/course",
  courses: "/api/course-select",
  courseTypes: "/api/courseType",
  locations: "/api/location",
  courseCategories: "/api/courseCategory",
  courseWeek: "/api/courseWeek",
  children: "/api/child",
  sendRegistration: "/api/send-registration",
  emtyWaitingQueue: "/api/empty-waiting-queue"
};
